import { render, staticRenderFns } from "./StopLive.vue?vue&type=template&id=2be156fe&scoped=true&"
import script from "./StopLive.vue?vue&type=script&lang=js&"
export * from "./StopLive.vue?vue&type=script&lang=js&"
import style0 from "./StopLive.vue?vue&type=style&index=0&id=2be156fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be156fe",
  null
  
)

export default component.exports